(() => {
  function initMediaTabs(root) {
    const tabsWrap = root.querySelector('[data-media-tabs]');
    if (!tabsWrap || tabsWrap.dataset.inited === '1') return;
    tabsWrap.dataset.inited = '1';

    const gallery = tabsWrap.closest('media-gallery') || root;
    const buttons = tabsWrap.querySelectorAll('[data-media-tab]');

    function setGroup(group) {
      buttons.forEach(b => b.classList.toggle('is-active', b.dataset.mediaTab === group));

      const slides = gallery.querySelectorAll('[id^="Slider-Gallery-"] [data-media-group]');
      const thumbs = gallery.querySelectorAll('[id^="Slider-Thumbnails-"] [data-media-group]');

      slides.forEach(li => { li.hidden = (li.dataset.mediaGroup !== group); });
      thumbs.forEach(li => { li.hidden = (li.dataset.mediaGroup !== group); });

      // sincroniza: abre la primera miniatura visible del grupo
      const firstThumbBtn = gallery.querySelector(
        `[id^="Slider-Thumbnails-"] [data-media-group="${group}"] button`
      );
      if (firstThumbBtn) firstThumbBtn.click();
    }

    buttons.forEach(btn => btn.addEventListener('click', () => setGroup(btn.dataset.mediaTab)));

    // estado inicial
    setGroup('product');
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('main').forEach(initMediaTabs);
  });
})();
